









































































import Vue from 'vue';
import { api, env, monitor } from '@/common';
import { toast, modal, ActionSheet } from '@mx/vix';
import Example from '@/components/Example.vue';
import {
  EXMPLE_IMAGE,
  DEFAULT_COLOR,
  PAGE_TYPE,
  PROCESS_TYPE,
  NfcBridgeType,
  IS_NFC_AVAILABLE,
  ERRORLEVELTYPES
} from './constans';
import { compareVersion } from '@mx/util/compare-version';

export default Vue.extend({
  components: {
    Example,
    ActionSheet
  },
  data() {
    return {
      userName: '',
      bottom_link_text: '',
      pageType: PAGE_TYPE.ID_CARD, // 0 上传身份证 1 手持身份证拍摄
      bizId: +env.bizId || 0,
      needHandIdPhoto: +env.needHandIdPhoto || 0,
      customId: env.customId || '0',
      exmpleImageList: EXMPLE_IMAGE,
      nbApp: env.appName || '', // 后端会做校验nb_app 与当前环境不一致会报错，默认值设为空，展示default color
      viewVo: DEFAULT_COLOR,
      isSuccessGetIdInfo: false, // 是否成功获取实名信息
      isShowCustomService: false, // 是否展示客服入口
      customJumpUrl: '', // 客服入口跳转链接
      isShowNfc: false, // 是否展示NFC入口
      nfcLink: '', // NFC入口地址
      nfcModeId: '',
      nfcReqsId: '',
      subId: '',
      nfcModeIph: '',
      isInBPassPort: env.payMemberId
    };
  },
  created() {
    if (/openharmony/.test(window.navigator.userAgent.toLocaleLowerCase())) {
      modal.show({
        title: '温馨提示',
        content: '身份证上传功能暂不适配当前系统，请您去美团APP-我的-右上角设置-支付设置-实名认证完成身份证上传。',
      })
      return;
    };
    // 获取实名信息
    this.getAuthentication();
  },
  mounted() {
    this.setLLButton();
    // cat数据备份
    this.$cat.addError('首页展示c_8q3178yy', this.lxCommonParams);
    // 是否展示NFC入口
    this.showNFCHanlder();
    // 是否展示客服入口
    this.showCustomServiceHandler();
    // 监控手持上传流量，若无流量考虑下线
    if (this.needHandIdPhoto) {
      monitor.captureJSErrorMessage('手持上传 needHandIdPhoto', {
        needHandIdPhoto: this.needHandIdPhoto, url: window.location.href
      });
    }

    this.$lx.pv('c_8q3178yy', {
      ...this.lxCommonParams,
      modeId: '-999',
      certify_session_id: '-999'
    });

  },
  computed: {
    nfcMarketInfo() {
      return env.isIOS ? '贴⼀贴身份证, 3秒上传' : '贴⼀贴身份证, 5秒上传';
    },
    // 头部提示文案
    headTipText(): object {
      return {
        actionText: this.pageType ? '拍摄' : '请上传',
        tipText: this.pageType ? '手持身份证照片' : '本人身份证'
      };
    },
    customColor(): object {
      if (this.viewVo.mainColor) {
        return {
          color: this.viewVo.mainColor
        };
      }
      return {};
    },
    btnCustomColor(): object {
      if (this.viewVo.mainColor) {
        return {
          color: this.viewVo.textColor,
          background: this.viewVo.mainColor
        };
      }
      return {};
    },
    lxCommonParams(): Record<string, any> {
      const params = {
        ...env.commonParams,
        item: this.bizId,
        utm_source: env.utmSource || '-999'
      };
      if (env.payMemberId) {
        return {
          ...params,
          payMemberId: env.payMemberId
        };
      }
      return params;
    }
  },
  methods: {
    // MC事件记录
    iconReportMC() {
      this.lxReport('b_pay_igpuw3aj_mc', {
        ...this.lxCommonParams,
        modeId: '-999'
      });
    },
    showNFCHanlder() {
      // 1. 这段代码的作用是判断当前环境是否为iOS设备、是否在美团App内，并且美团App的版本号是否大于等于12.11.400
      // 2. 如果满足以上条件，则直接返回，不执行后续逻辑
      // 3. iOS版本小于12.11.200不支持NFC，但是12.11.400之前的iOS版本跳转有问题，所以在这里做限制
      if (
        env.isIOS &&
        env.isInMeituan &&
        compareVersion(env.commonParams.appVersion, '12.11.400') === -1
      ) {
        return;
      }
      api
        .queryBizInfo({
          bizId: env.bizId
        })
        .then((result) => {
          if (!result || !result.nfcModeId || !result.ui) {
            monitor.captureAjaxErrorMessage('queryBizInfo接口异常', result);
            return;
          }
          env.commonParams.certify_session_id = result.certify_session_id;
          this.lxCommonParams.certify_session_id = result.certify_session_id;
          this.nfcModeId = result.nfcModeId;
          const uiContent = JSON.parse(result.ui);
          const { enableNFC, nfcModeIph } = uiContent;
          this.nfcModeIph = nfcModeIph;
          if (enableNFC) {
            this.judgeNFCAvailable().then(() => {
              this.$lx.mv('b_pay_h3l4haza_mv', {
                ...this.lxCommonParams,
                modeId: this.nfcModeId
              });
              this.isShowNfc = true;
            });
          }
        })
        .catch((err: any) => {
          this.isShowNfc = false;
          monitor.captureJSErrorMessage('NFC入口展示异常', err);
        });
    },
    // 判断NFC桥能力是否具备
    judgeNFCAvailable() {
      return new Promise((res, rej) => {
        this.nfcIdentify(
          'isNFCAvailable',
          (data: NfcBridgeType) => {
            const { status, isNFCAvailable } = data;
            toast.hide();
            if (status === 'success') {
              if (isNFCAvailable === IS_NFC_AVAILABLE.NOT_SUPPORT) {
                return rej();
              } else {
                return res();
              }
            } else {
              const { errorCode, errorMsg } = data;
              return rej(`NFC调桥 Native异常 ${errorCode}-${errorMsg}`);
            }
          },
          (err: any) => {
            return rej(err);
          }
        );
      });
    },
    nfcIdentify(
      action: string,
      success: (res: any) => void,
      fail: (res: any) => void
    ) {
      this.$bridge.nfcIdentifyProcess({
        action,
        success,
        fail
      });
    },
    createNFCCertifyUrl() {
      // 设置超时时间
      toast.show('loading', '请稍后');
      const nfcJumpTimer = setTimeout(() => {
        toast.show('text', '系统异常，请尝试其他上传方式');
        clearTimeout(nfcJumpTimer);
      }, 6000);
      const param = {
        modeId: this.nfcModeId || '',
        payMemberId: env.payMemberId || '',
        iph: this.nfcModeIph,
        validTime: 3600
      };
      return api
        .createNFCCertifyUrl(param)
        .then((res) => {
          clearTimeout(nfcJumpTimer);
          toast.hide();
          if (!res) {
            // 接口异常不阻塞用户上传流程，进入上传流程
            throw new Error();
          } else {
            if (!res.requestId || !res.link) {
              throw new Error();
            }
            this.nfcReqsId = res.requestId;
            this.nfcLink = res.link;
          }
        })
        .catch((err) => {
          toast.hide();
          clearTimeout(nfcJumpTimer);
          this.apiErrorHandler(err);
        });
    },
    // 跳转NFC流程
    nfcBtnHandler() {
      toast.show('loading', '请稍后');
      this.createNFCCertifyUrl().then(() => {
        this.$bridge.subscribe({
          action: 'appear',
          handle: () => {
            this.$bridge.unSubscribe({
              subId: this.subId,
              action: 'appear',
              success: () => void(0),
              fail: () => void(0)
            });
            this.$bridge.getResult({
              success: () => {
                this.submitCertificateInfoByNfc();
              },
              fail: () => {
                this.$bridge.getStorage({
                  key: 'VERIFIED_SDK_UPLOAD_IDENTITY_MESSAGE',
                  success: (res) => {
                    if (res.value) {
                      this.submitCertificateInfoByNfc();
                    } else {
                      toast.hide();
                      monitor.captureJSErrorMessage(
                        'NativeOcr getStorage获取NFC流程返回数据异常',
                        res
                      );
                    }
                  },
                  fail: (err) => {
                    toast.hide();
                    monitor.captureJSErrorMessage(
                      'NativeOcr getStorage获取NFC流程返回数据异常',
                      err
                    );
                  }
                });
              }
            });
          },
          success: (data) => {
            this.subId = data.subId;
            monitor.captureResourceInfoMessage(
              '[正常流程](upload-process)触发NFCappear事件'
            );
            if (this.nfcLink) {
              this.$lx.mc('b_pay_h3l4haza_mc', {
                ...this.lxCommonParams,
                modeId: this.nfcModeId
              });
              this.$bridge.openWebView(this.nfcLink);
            } else {
              toast.hide();
              monitor.captureJSErrorMessage(
                'createNFCCertifyUrl:: 失败：返回link数据异常'
              );
            }
          },
          fail: (fail: any) => {
            monitor.captureJSErrorMessage(
              '资质上传页面获取NFC流程返回数据异常',
              fail
            );
          }
        });
      });
    },
    submitCertificateInfoByNfc() {
      toast.show('loading', '请稍后');
      const nfcSubmitTimer = setTimeout(() => {
        toast.hide();
        toast.show('text', '系统异常，请稍后重试');
        clearTimeout(nfcSubmitTimer);
      }, 6000);
      api
        .submitCertificateInfoByNfc({
          requestId: this.nfcReqsId,
          payMemberId: env.payMemberId,
          bizId: this.bizId
        })
        .then((result) => {
          toast.hide();
          clearTimeout(nfcSubmitTimer);
          console.log(result);
          if (!result) {
            throw new Error();
          } else {
            if (env.isIOS) {
              this.identifyIdCardProcess(
                PROCESS_TYPE.NOTIFY_FINISH_IOS,
                (res) => {
                  this.closePage();
                  this.setResult(res, 'iOSnfc通知native成功');
                },
                (res) => {
                  toast.show('text', '系统异常，请稍后重试');
                  this.setResult(res, 'iOSnfc通知native失败');
                }
              );
            } else {
              this.setResult({ ...result, status: 'success' }, 'NFC上传成功');
              this.closePage();
            }
          }
        })
        .catch((err) => {
          toast.hide();
          clearTimeout(nfcSubmitTimer);
          this.apiErrorHandler(err);
          this.setResult(err, 'NFC上传失败');
        });
    },
    apiErrorHandler(error: any) {
      const { code, level, message } = error.error;
      if (`${code}` === '405003') {
        if (this.isInBPassPort) {
          toast.show('error', message);
        } else {
          modal.show({
            title: '验证失败',
            content: `照片证件号与账号实名信息不一致，请上传 ${this.userName} 本人的证件照片`,
            className: 'verified-double-btn-modal',
            preventScroll: true,
            closeButton: true,
            button: [
              {
                text: '账号实名变更',
                onClick: () => {
                  this.$bridge.jumpWebView(
                    'https://paymp.meituan.com/verified-sdk/change-realName.html'
                  );
                }
              },
              {
                text: '重新上传',
                onClick: () => {
                  modal.hide();
                }
              }
            ]
          });
        }
        this.$nextTick(() => {
          const els = document.getElementsByClassName('btn-main') as any;
          if (els) {
            els[0].style.background = this.viewVo.mainColor;
            els[0].style.color = this.viewVo.textColor;
          }
        });
        return;
      }
      if (level === ERRORLEVELTYPES.showModal) {
        modal.show({
          title: '识别失败',
          content: `<div style="text-align:center; padding:0 0.12rem 0">${
            message || '请重新上传证件照片'
          }</div>`,
          preventScroll: true,
          className: 'verified-modal verified-modal-text',
          closeButton: true,
          button: [
            {
              text: '重新上传',
              onClick: () => {
                modal.hide();
              }
            }
          ]
        });
        this.$nextTick(() => {
          const els = document.getElementsByClassName('btn-main') as any;
          if (els) {
            els[0].style.background = this.viewVo.mainColor;
            els[0].style.color = this.viewVo.textColor;
          }
        });
      } else {
        toast.show('error', message || '系统异常，请选择其他认证方式');
      }
    },
    showCustomServiceHandler() {
      api
        .getFaqUrl({
          nb_app: this.nbApp,
          pageCode: 'c_8q3178yy',
          faqType: 2
        })
        .then((resp) => {
          if (resp) {
            const { link, name } = resp;
            if (link) {
              this.customJumpUrl = link;
              if (env.isTitans) {
                this.$bridge.setRRButton(this.jumpCustomService, name || '');
              } else {
                this.isShowCustomService = true;
                this.bottom_link_text = name || '';
              }
            }
          }
        });
    },
    // 跳转客服
    jumpCustomService() {
      if (this.customJumpUrl) {
        this.$bridge.openWebView(this.customJumpUrl);
      }
    },
    // 获取实名信息
    getAuthentication() {
      api
        .getAuthentication({
          bizId: this.bizId,
          customerId: this.customId,
          mwalletToken: env.mwalletToken,
          payMemberId: env.payMemberId,
          nb_app: this.nbApp
        })
        .then((res) => {
          if (res && res.identityCardInfo) {
            this.userName = res.identityCardInfo.userName;
          }
          if (res && res.viewVo) {
            this.viewVo = res.viewVo;
          }
          // 实名信息获取成功再展示按钮，防止按钮变色，失败关闭webview
          this.isSuccessGetIdInfo = true;
          this.catReport('paybiz_dispatch_verify_ocr', 0);
        })
        .catch((error) => {
          this.identifyIdCardProcess(
            PROCESS_TYPE.API_ERROR,
            (res) => {
              this.setResult(res, '实名信息获取失败通知');
            },
            (res) => {
              this.setResult(res, '实名信息获取失败通知fail');
            }
          );
          this.catReport('paybiz_dispatch_verify_ocr', error.code);
          this.closePage();
        });
    },
    // 开始拍摄按钮事件绑定
    uploadBtnHandler() {
      if (this.pageType) {
        this.handUpload();
      } else {
        this.cameraUpload();
      }
    },
    // 手持上传
    handUpload() {
      this.identifyIdCardProcess(
        PROCESS_TYPE.HAND,
        (res) => {
          // 安卓setResult 成功
          this.setResult(res, '手持成功');
          this.closePage();
        },
        (res) => {
          // 安卓setResult 失败
          this.setResult(res, '手持失败');
        }
      );
      this.lxReport('b_7wfpdia3', this.lxCommonParams);
    },
    // 拍照上传
    cameraUpload() {
      this.identifyIdCardProcess(
        PROCESS_TYPE.PHOTO,
        (res) => {
          // iphone6P 上无法立刻拿到 success 回调，延迟 200ms即可。对其他机型影响不大。
          // 只有拍照上传有这个问题，相册上传没有此问题
          setTimeout(() => {
            if (this.needHandIdPhoto) {
              this.pageType = PAGE_TYPE.HAND_CARD;
            } else {
              this.setResult(res, '拍身份证成功');

              // 2023.12 新增需求，详见：https://km.sankuai.com/collabpage/2042944657
              toast.show('success',  '上传成功', { duration: 2000 });
              this.$lx.mv('b_pay_qaq0x3cq_mv', {
                ...this.lxCommonParams,
                modeId: this.nfcModeId,
                biz_id: this.bizId,
                certificate_upload_type: 1
              });
              setTimeout(() => {
                this.closePage();
              }, 2000);
            }
          }, 200);
        },
        (res) => {
          this.setResult(res, '拍身份证失败');
        }
      );
      this.lxReport(
        'b_btzsic5m',
        Object.assign({}, this.lxCommonParams, { button_id: 'shoot' })
      );
    },
    // 相册上传
    photosUpload() {
      this.identifyIdCardProcess(
        PROCESS_TYPE.ALBUM,
        (res) => {
          if (this.needHandIdPhoto) {
            this.pageType = PAGE_TYPE.HAND_CARD;
          } else {
            this.setResult(res, '相册上传成功');

            // 2023.12 新增需求，详见：https://km.sankuai.com/collabpage/2042944657
            toast.show('success',  '上传成功', { duration: 2000 });
            this.$lx.mv('b_pay_qaq0x3cq_mv', {
              ...this.lxCommonParams,
              modeId: this.nfcModeId,
              biz_id: this.bizId,
              certificate_upload_type: 2
            });
            setTimeout(() => {
              this.closePage();
            }, 2000);
          }
        },
        (res) => {
          this.setResult(res, '相册上传失败');
        }
      );
      this.lxReport(
        'b_btzsic5m',
        Object.assign({}, this.lxCommonParams, { button_id: 'album' })
      );
    },
    // 关闭当前webview
    closePage() {
      this.$bridge.closeWebView();
    },
    // 设置左上角返回按钮，埋点用
    setLLButton() {
      // 展示导航栏
      try {
        // 重置RRButton
        this.$bridge.resetNavButton();
        this.$bridge.showNavigationBar();
      } catch (err) {
        console.log(`展示导航栏失败${err}`);
      }
      this.$bridge.setLLButton(() => {
        this.lxReport('b_vygb3gbw', this.lxCommonParams);
        // 手持需要走弹窗提示
        if (this.pageType) {
          modal.show({
            content: '现在离开需要重新上传身份证正反面照片，确认需要离开吗？',
            button: [
              {
                text: '取消',
                onClick: () => modal.hide()
              },
              {
                text: '确认',
                onClick: this.processCancel
              }
            ]
          });
        } else {
          this.processCancel();
        }
      });
    },
    // 身份验证桥 process 1 进行身份证正反面拍照并上传, 2 调起相册, 3 进行手持身份证拍照并上传, 4 cnacel
    // h5 新增参数 mainColor 实现定制色，但和 Native 间的通信参数未做改动维持原来 commonColor
    identifyIdCardProcess(
      process: number,
      success: (res: any) => void,
      fail: (res: any) => void
    ) {
      this.$bridge.identifyIdCardProcess({
        process,
        bizId: this.bizId,
        customId: this.customId,
        commonColor: this.viewVo.mainColor || '#FFC300',
        textColor: this.viewVo.textColor || '#222222',
        success,
        fail
      });
    },
    // cat桥调用
    catReport(action: string, code: number) {
      // cat数据备份
      this.$cat.addError(action, {
        code
      });
    },
    // 灵犀桥调用
    lxReport(bid: string, val: object) {
      this.$lx.mc(bid, { ...val });
      // cat数据备份
      this.$cat.addError(bid, val);
    },
    // 取消退出
    processCancel() {
      this.identifyIdCardProcess(
        PROCESS_TYPE.CANCEL,
        (res) => {
          this.setResult(res, 'cancel');
        },
        (res) => {
          this.setResult(res, 'cancel失败');
        }
      );
      this.closePage();
    },
    setResult(res: any, name: string) {
      this.$bridge.setResult({
        resultCode: KNB.setResult.RESULT_OK,
        resultData: JSON.stringify(res),
        success: () => {
          this.$cat.addError(name + '_setResult', {
            res
          });
        },
        fail: () => {
          this.$cat.addError(name + '_setResult_fail', {
            res
          });
        }
      });
      this.$cat.addError(name, {
        res
      });
    }
  }
});
